<template>
    <div>
        <div v-for="item in StdQuery" :key="item" @click="openDetail(item)">
            <van-cell is-link
                      :title="item.ExternalUserId">
                <template #title>
                    <div class="title">
                        <van-image
                                round
                                width="20px"
                                height="20px"
                                fit="cover"
                                :src="item.Avatar"
                        />
                        {{ item.Name }}
                    </div>

                </template>
                <template>
                    <div>
                        {{ item.StatusMemo }}-{{ item.CreateDate }}
                    </div>
                </template>
            </van-cell>
            <van-cell>
                <template #title>
                    <div v-if="item.ExpectAmount" style="padding-top: 12px">预计成交:{{ item.ExpectAmount }}
                    </div>
                </template>
                <template>
                    <div>
                        {{ item.IndustryDesc }}-{{ item.StatusMemo }}
                    </div>
                </template>
            </van-cell>
            <div class="status_memo">{{ item.LastMemo }}
                <div class="font12" style="padding-top: 12px">{{ item.LastMemoDate }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    data() {
        return {
            Date: "",
            StdQuery: []
        }
    },
    async created() {
        const route = this.$route;
        let _this = this
        this.$nextTick(async () => {
            let _data = await _this.$frame.getStdQueryData("UserDataReportPauseList", {
                RelUserId: route.query.RelUserId
            })
            _this.StdQuery = _data.StdQuery
        })

    },
    methods: {
        openDetail(item) {
            this.$router.push({
                path: "/work/detail",
                query: {
                    ExternalUserId: item.ExternalUserId
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.title {
    display: flex;
    align-items: center;

    ::v-deep {
        .van-image {
            margin-right: 12px;
        }
    }
}

.status_memo {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 12px;
    box-shadow: $base-box-shadow;
}
</style>
